import React, { ReactElement } from "react";

interface Props {
  onClick?: () => void;
}

export function AppDimmer(props: Props): ReactElement {
  return <div className="AppDimmer" onClick={props.onClick} />;
}
